'use client';

var HIDDEN_MSG = '_HIDDEN_';

export { HIDDEN_MSG };
//# sourceMappingURL=constant.js.map
